import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { useEffect, useRef, memo, useContext } from 'react'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'
import { UserContext } from '../../context/UserContext'

const CalendarMonth = (props) => {
  const { year, month, monthLabels } = props

  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const monthRef = useRef()

  useEffect(() => {
    const calendarNav = document.querySelector('.CalendarNavigation-navSelect')
    ScrollTrigger.create({
      trigger: monthRef.current,
      start: '-100 center',
      end: '100 center',
      onToggle: () => {
        if (calendarNav) calendarNav.value = `${year}.${month}`
      }
    })
  }, [])

  return (
    <h3 className="CalendarMonth" data-month={`${year}.${month}`} ref={monthRef}>
      {t(monthLabels[month])}
    </h3>
  )
}

CalendarMonth.propTypes = {
  year: PropTypes.number,
  month: PropTypes.number,
  monthLabels: PropTypes.array
}

export default memo(CalendarMonth, (prevProps, nextProps) => {
  return false
})
